import React from 'react';
import ReactTable from "react-table";
import { Row, Col, Button, FormGroup, Form, InputGroup } from 'react-bootstrap';
import Select from 'react-select';

import "react-table/react-table.css";

import 'bootstrap/dist/css/bootstrap.css';
import { uniq } from 'underscore';
import FontAwesome from 'react-fontawesome';
import ReactGA from 'react-ga';
import { export2Excel, sortNumber, filterNumber, filterMultiple, getFilteredData, setDataForExpansion, getSum, getExpander } from '../../gridHelpers/gridHelpers';

import NPHelpButton from '../../NPHelpButton';
import NPEditableCell from '../QuickEdit/EditableCell/index'
import OrderConfirmationModal from '../QuickEdit/OrderConfirmationModal/index'

import './style.scss';
import moment from 'moment';
import constants, { ORDER_STATUS_ACTIVE, WO_PRELIMINARY, WO_RELEASED } from '../.././util/constants';
import axios from 'axios';
import NPSpinnerModal from '../../NPSpinnerModal';
import LoadingSpinner from '../../LoadingSpinner';
import NPReactTable from '../../NPReactTable';
import Dialog from 'react-bootstrap-dialog';
import * as Grants from '../.././util/grants';
import { hasGrant } from '../.././util/grantHelper';
import { Command } from '../../OrderCreate/common';
import * as orderUtil from '../../util/order.helper'
import * as Convert from '../../util/unitConversion';


const quickEditHelpNode = (
    <div>
        <h4>Cells with decimal values</h4>
        <p>Adding decimal values only works with dots, ".", not commas. </p>

        <h4>Orders available for quickedit</h4>
        <p>All orders are available to edit except those with the status <b>Shipped</b></p>


        <h4>Editing quantity or weight</h4>
        <p>Only one option is available per order row, defined by how the order was created.</p>
        <p>The option not available will be automatically updated.</p>


        <h4>Exmill week</h4>
        <p>Exmill works by showing year and a week number. Add only the weeknumber, and it will select the year automatically.</p>

    </div>
)


class OrderSearchDataTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.getClearedState();
        this.resetState = this.resetState.bind(this);
        // this.handleClientSelectChange = this.handleClientSelectChange.bind(this);
        // this.handleProductCodeSelectChange = this.handleProductCodeSelectChange.bind(this);
        this.tell = this.tell.bind(this);
        this.help = this.help.bind(this);
        this.excelExport = this.excelExport.bind(this);
        this.updateSums = this.updateSums.bind(this);
        this.getSums = this.getSums.bind(this);
        this.getcolumns = this.getcolumns.bind(this);
        this.getClearedState = this.getClearedState.bind(this);
        this.clearCurrentExpandforAll = this.clearCurrentExpandforAll.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.isRowOkForRelease = this.isRowOkForRelease.bind(this);
        this.setReactTable = this.setReactTable.bind(this);
        this.reloadWithClient = this.reloadWithClient.bind(this);
        this.cloneOrderRow = this.cloneOrderRow.bind(this);
        this.getCloneableOrders = this.getCloneableOrders.bind(this);
        this.selectCopyToOrder = this.selectCopyToOrder.bind(this);
        this.getCombo = this.getCombo.bind(this);
        this.getUserType = this.getUserType.bind(this);
        this.refreshData = this.refreshData.bind(this);
        /*quick edit functions  */
        this.editTable = this.editTable.bind(this);
        this.editOrderCallback = this.editOrderCallback.bind(this);
        this.quickSaveOrderItems = this.quickSaveOrderItems.bind(this);
        this.saveEditedOrders = this.saveEditedOrders.bind(this);
        this.saveConfirmedOrders = this.saveConfirmedOrders.bind(this);
        this.toggleOrderModal = this.toggleOrderModal.bind(this);
        this.closeSpinnnerModal = this.closeSpinnnerModal.bind(this);
        this.canRowCancelOrder = this.canRowCancelOrder.bind(this);
        // this.getWeightOrQuantity = this.getWeightOrQuantity.bind(this);
        // this.getQuantityByWeight = this.getQuantityByWeight.bind(this);
    }

    componentDidMount() {
        this.getUserType();
    }

    getUserType() {
        this.setState({ userType: window.sessionStorage.getItem('UserType') });
    }

    releaseOrder(row, self) {
        const { API_BASE_URL } = constants;
        const header = {
            'Authorization': 'Bearer ' + self.props.apiToken,
            'Accept': 'application/octet-stream'
        };
        self.setState({ showSpinnerModal: true, modalTitle: 'Releasing order', modalContent: 'Order ' + row.ORDER_NUMBER + ' released', releasingOrder: true });

        axios.post(API_BASE_URL + 'OrderEntry/ReleaseOrder', { OrderNumber: row.ORDER_NUMBER, ModUserDateTime: row.MODUSER_DATETIME }, { headers: header })
            .then(result => {
                let modalContent = null;
                if (result.data?.Validation === null || result.data.Validation.Validated) {
                    modalContent = 'Successfully released order';
                    this.props.viewOrderCommand(-1, 0, 0);
                }
                else {
                    modalContent = orderUtil.getValidationErrorContent(result.data.Validation.Errors, row.orderNumber)
                }

                self.setState({ releasingOrder: false, modalContent: modalContent});
                
            })
            .catch(error => {
                let msg = '';
                if (error.response.data) {
                    msg = error.response.data;
                }

                self.setState({ releasingOrder: false, modalContent: 'Failed to release order ' + row.ORDER_NUMBER + ', ' + msg });
                //alert(error);
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                }
                else {
                    console.log('no error.response');
                }
            });
    }

    cancelOrder(row, self) {
        const { API_BASE_URL } = constants;
        const header = {
            'Authorization': 'Bearer ' + self.props.apiToken,
            'Accept': 'application/octet-stream'
        };
        self.setState({ showSpinnerModal: true, modalTitle: 'Cancelling order', modalContent: 'Order ' + row.ORDER_NUMBER + ' cancelled', releasingOrder: true });

        axios.post(API_BASE_URL + 'OrderEntry/CancelOrder', { OrderNumber: row.ORDER_NUMBER, ModUserDateTime: row.MODUSER_DATETIME }, { headers: header })
            .then(result => {
                let modalContent = 'Successfully cancelled order';
                this.props.viewOrderCommand(-1, 0, 0);
                self.setState({ releasingOrder: false, modalContent: modalContent});
            })
            .catch(error => {
                let msg = '';
                if (error.response.data) {
                    msg = error.response.data;
                }

                self.setState({ releasingOrder: false, modalContent: 'Failed to cancel order ' + row.ORDER_NUMBER + ', ' + msg });
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                }
                else {
                    console.log('no error.response');
                }
            });
    }

    openReleased(row, self) {
        const { API_BASE_URL } = constants;
        const header = {
            'Authorization': 'Bearer ' + self.props.apiToken,
            'Accept': 'application/octet-stream'
        };
        self.setState({showSpinnerModal: false});

        self.setState({ showSpinnerModal: true, modalTitle: 'Opening up order', modalContent: 'Order ' + row.ORDER_NUMBER + '-' + row.ORDER_ITEM_NUMBER + ' set to WO_PRELIMINARY', releasingOrder: true });

        axios.post(API_BASE_URL + 'OrderEntry/OpenReleased', { OrderNumber: row.ORDER_NUMBER, OrderItemNumber: row.ORDER_ITEM_NUMBER, ModUserDateTime: row.MODUSER_DATETIME }, { headers: header })
            .then(result => {
                self.setState({ releasingOrder: false });
                this.props.viewOrderCommand(-1, 0, 0);
            })
            .catch(error => {
                let msg = '';
                if (error.response.data) {
                    msg = error.response.data;
                }

                self.setState({ releasingOrder: false, modalContent: 'Failed to open up order ' + row.ORDER_NUMBER + ', ' + msg });
                //alert(error);
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                }
                else {
                    console.log('no error.response');
                }
            });
    }

    quickSaveOrderItems(self, orders) {
        const { API_BASE_URL } = constants;
        const header = {
            'Authorization': 'Bearer ' + self.props.apiToken,
            'Accept': 'application/octet-stream'
        };

        let quickEditTemp = self.state.quickEdit;
        quickEditTemp.savingOrders = true;
        this.setState({ quickEdit: quickEditTemp, showSpinnerModal: true, modalTitle: 'Saving orders' });

        axios.post(API_BASE_URL + 'OrderEntry/SaveOrderItems', orders, { headers: header })
            .then(result => {
                let quickEditTemp = self.state.quickEdit;
                quickEditTemp.editTable = false;
                quickEditTemp.savingOrders = false;
                quickEditTemp.editedOrders = [];
                let filters = this.state.filteredTemp;
                let sorts = this.state.sortedTemp;

                self.setState({ quickEdit: quickEditTemp, modalTitle: 'Success!', modalContent: 'Orders have been saved', filtered: filters, sorted: sorts }, () => setTimeout(() => { self.refreshData(); }, 2000));
            })
            .catch(error => {
                let errorMessage = error?.response?.status === 400 && error?.response?.data || "An error occured during save, please try again later.";
                let quickEditTemp = self.state.quickEdit;
                quickEditTemp.editTable = true;
                quickEditTemp.savingOrders = false;
                let filters = this.state.filteredTemp;
                let sorts = this.state.sortedTemp;

                self.setState({ quickEdit: quickEditTemp, modalTitle: 'Error saving orders!', modalContent: errorMessage, filtered: filters, sorted: sorts });
            })
    }

    getCombo(_caption, _stateObj, _onChange, _placeHolder, _options, _width = "150px", _clearable = true, disabled = false) {
        let mystyle = {
            padding: "10px",
            width: _width ?? "150px",
            borderRadius: "5px",
            marginRight: '10px'
        }

        return (
            <div>
                <select style={mystyle} placeholder={_placeHolder} onChange={(item) => _onChange(item, _stateObj)}>
                    {_options.map((object) => { return (<option value={object.value}>{object.label}</option>) })}
                </select>
            </div>
        );
    }

    selectCopyToOrder(item) {
        this.setState({ selectedCloneableOrder: item.target.value });
    }

    getCloneableOrders(order, customer, orderNumber) {
        function onlyUnique(value, index, arr) {
            return arr.map(o => o.ORDER_NUMBER).indexOf(value.ORDER_NUMBER) === index;
        }
        let kraft = window.sessionStorage.getItem('LegalEntity') === 'NPBA';
        let orders = kraft ? this.props.data.filter(o => o.ITEM_STATUS === 'WO Preliminary' && o.CLIENT_CODE_REGIONAL === order.CLIENT_CODE_REGIONAL
            && o.ORDER_NUMBER !== order.ORDER_NUMBER && o.WAREHOUSE === order.WAREHOUSE)
            : this.props.data.filter(o => o.ITEM_STATUS === 'WO Preliminary' && o.CLIENT_CODE_REGIONAL === order.CLIENT_CODE_REGIONAL && o.ORDER_NUMBER !== order.ORDER_NUMBER);
        let uniqueOrders = orders.filter(onlyUnique).map(order => ({ 
            label: (order.ORDER_NUMBER + ', Last modified: ' + order.MODUSER_DATETIME ?? ''), 
            value: order.ORDER_NUMBER, 
            payload: { ORDER_NUMBER: order.ORDER_NUMBER, MODUSER_DATETIME: order.MODUSER_DATETIME} 
        }));
        let defaultOrder = { label: 'Order Number', value: {} };
        uniqueOrders.unshift(defaultOrder);
        return uniqueOrders;
    }

    cloneOrderRow(row, intoOrder) {
        let self = this;
        const { API_BASE_URL } = constants;
        const header = {
            'Authorization': 'Bearer ' + self.props.apiToken,
            'Accept': 'application/octet-stream'
        };
        self.setState({ showSpinnerModal: true, modalTitle: 'Cloning row into order', modalContent: 'Order ' + row.ORDER_NUMBER + ' cloned', releasingOrder: true });
        
        let selOrder = self.state.cloneableOrders.find(i => (i?.payload?.ORDER_NUMBER ?? '')=== intoOrder);
        let dateTime = selOrder?.payload?.MODUSER_DATETIME;

        if(selOrder && dateTime)
        {
            axios.post(API_BASE_URL + 'OrderEntry/CloneOrderRow', { OrderNumber: row.ORDER_NUMBER, OrderItemNumber: row.ORDER_ITEM_NUMBER, IntoOrderNumber: intoOrder, ModUserDateTime: dateTime }, { headers: header })
            .then(result => {
                self.setState({ releasingOrder: false });
                this.props.viewOrderCommand(-1, 0, 0);
            })
            .catch(error => {
                let msg = '';
                if (error.response.data) {
                    msg = error.response.data;
                }

                self.setState({ releasingOrder: false, modalContent: 'Failed to clone from order ' + row.ORDER_NUMBER + ', ' + msg });
                //alert(error);
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                }
                else {
                    console.log('no error.response');
                }
            });
        }
        else {
            self.setState({ releasingOrder: false, modalContent: 'Chosen order is not eligable for cloning' });

        }
    }

    resetState() {
        this.setState(this.getClearedState());
    }

    handleSelectChange(evt, item, row, self) {
        if (item && row && row.original) {
            if (item === 'Release') {
                this.releaseOrder(row.original, this);
                evt.currentTarget.selectedIndex = 0;
            }
            else if (item === 'OpenReleased') {
                this.openReleased(row.original, this);
                evt.currentTarget.selectedIndex = 0;
            }
            else if (item === 'CopyTo') {
                let uniqueOrders = this.getCloneableOrders(row.original);
                // this.setState({cloneableOrders: uniqueOrders, modalTitle: 'Copy order row into existing preliminary order', showCopyModal: true});
                this.setState({ cloneableOrders: uniqueOrders }, () => {
                    // this.setState({modalTitle: 'Copy order row into existing preliminary order', showCopyModal: true});
                    this.dialog.show({
                        title: "Copy order row into existing preliminary order",
                        body: this.getCombo('Copy to order', "selectedCloneableOrder", this.selectCopyToOrder, 'Order number', this.state.cloneableOrders, '260px'),
                        actions: [
                            Dialog.CancelAction(() => {
                                return;
                            }),
                            Dialog.OKAction((res) => {
                                let data = res;
                                this.cloneOrderRow(row.original, this.state.selectedCloneableOrder);
                            }),
                        ]

                    })
                }
                );
            }
            else if (item === 'CancelOrder') {
                this.setState(() => {
                    // this.setState({modalTitle: 'Copy order row into existing preliminary order', showCopyModal: true});
                    this.dialog.show({
                        title: "Cancel order",
                        body: <div>Please beware:<br/>This action will cancel the order including all order items and it will no longer show up in this view. <br/>
                              Nordic Paper customer service can still access and see the order.</div>,
                        actions: [
                            Dialog.CancelAction(() => {
                                return;
                            }),
                            Dialog.OKAction((res) => {
                                this.cancelOrder(row.original, this);
                            })
                        ], 
                        bsSize: 'medium'
                    })
                }
                );
            }
            else if (item !== '...') {
                let selIndex = this.getOrderAction(item);
                evt.currentTarget.selectedIndex = 0;


                let props = this.props;
                if (window.sessionStorage.getItem("LegalEntity") === 'NPBA' && selIndex == 3 && props.data.filter(d => { return d.ORDER_NUMBER == row.original.ORDER_NUMBER && d.WAREHOUSE != row.original.WAREHOUSE }).length > 0) {
                    setTimeout(function () {
                        self.dialog.show({
                            title: "This order contains items from more than one warehouse",
                            body: "This order contains items from more than one warehouse, only items from the same warehouse as the selected will be copied",
                            actions: [
                                Dialog.CancelAction(() => {
                                    return;
                                }),
                                Dialog.OKAction(() => {
                                    props.viewOrderCommand(selIndex, row.original.ORDER_NUMBER, row.original.ORDER_ITEM_NUMBER);
                                })
                            ]

                        });
                    }, 200);
                }
                else {
                    this.props.viewOrderCommand(selIndex, row.original.ORDER_NUMBER, row.original.ORDER_ITEM_NUMBER);
                }
            }
        }
    }

    getOrderAction(action) {
        switch (action) {
            case "CopyThis":
                return Command.CopyOne;
            case "CopyAll":
                return Command.CopyAll;
            case "CopyTo":
                return Command.CopyTo;
            case "Edit":
                return Command.Modify;
            default:
                return -1;
        }
    }

    canRowOpenReleased(row) {
        return hasGrant(Grants.TYPES.Order_SetOrderBackToPreliminary) && row.original.ORDER_ITEM_STATUS === WO_RELEASED;
    }

    canRowCancelOrder(row) {
        let orderItems = this.props.data.filter(x=>x.ORDER_NUMBER === row.original.ORDER_NUMBER);

        if(!orderItems){
            return false;
        }

        if(orderItems.every(x=>x.ORDER_ITEM_STATUS === WO_RELEASED || x.ORDER_ITEM_STATUS === WO_PRELIMINARY) == false){
            return false;
        }
        
        if(hasGrant(Grants.TYPES.Order_CancelReleased)){
            return true;
        }
        
        if(orderItems.some(x=>x.ORDER_ITEM_STATUS === WO_RELEASED)){
            return false;
        }

        return true;
    }


    isRowOkForModification(row) {
        let kraft = window.sessionStorage.getItem("LegalEntity") === 'NPBA';
        let allowed = kraft ? window.sessionStorage.getItem("Role") === 'Administrator' || window.sessionStorage.getItem("Role") === 'Internal' : true;

        let rows = this.props.data && this.props.data.filter(d => d && d.ORDER_NUMBER == row.original.ORDER_NUMBER && d.ORDER_STATUS == ORDER_STATUS_ACTIVE);
        if (allowed) {
            let goodRows = rows && rows.filter(r => r && r.ORDER_STATUS === ORDER_STATUS_ACTIVE && (r.ORDER_ITEM_STATUS === WO_PRELIMINARY || r.ORDER_ITEM_STATUS === WO_RELEASED));
            let goodRow = goodRows && goodRows.find(r => r && r.ORDER_ITEM_STATUS === WO_PRELIMINARY);

            return (rows && rows.length > 0 && goodRows.length === rows.length && goodRow);
        }
        else {
            let wrongstatus = rows && rows.find(d => d
                && d.ORDER_NUMBER == row.original.ORDER_NUMBER
                && (d.ORDER_STATUS !== ORDER_STATUS_ACTIVE || d.ORDER_ITEM_STATUS !== WO_PRELIMINARY)
            );

            return (rows && rows.length > 0 && wrongstatus === undefined);
        }
    }

    NullOr0(value) {
        return !value || value < 0 || value == 0;
    }

    DateAfterNow(value) {
        return value > moment().format('YYYY-MM-DD');
    }

    isRowOkForRelease(row) {
        if (!this.isRowOkForModification(row)) {
            return false;
        }
        let rows = this.props.data && this.props.data.filter(d => d && d.ORDER_NUMBER == row.original.ORDER_NUMBER);
        let wrongstatus = rows && rows.find(d => d &&
            (this.NullOr0(d.QUANTITY) || this.NullOr0(d.WEIGHT_UC) || (hasGrant(Grants.TYPES.Order_EditPrice) && this.NullOr0(d.UNIT_PRICE_COMMITTED)) ||
                !this.DateAfterNow(row.original.EXMILL)));
        return (rows && rows.length > 0 && wrongstatus === undefined);
    }



    getcolumns() {

        const helpNode = (
            <div>
                <h3>Buttons</h3>

                <h4>Reset</h4>
                <p>Resets filters, sorting, column widths and navigates to first page.</p>

                <h4>Excel</h4>
                <p>Exports the data to excel according to filters and sorting.</p>

                <h3>Filters</h3>

                <p>There are fields at the top of the table that can be used for filtering</p>

                <p>
                    If a text box for a column is empty, no filtering for that column will be done.<br />
                    If the data is left-aligned and the text box is not empty, the filter will remove rows that do not contain the text in the text box<br />
                    It is possible to use multiple filters for text based values by writing a comma, for example "Ordered, Being produced"<br /><br />
                    Examples follows for right-aligned (numbers):<br />
                    Empty text box, no filtering.<br />
                    <strong>&lt; 10</strong> view rows with data that is less than 10<br />
                    <strong>&gt; 10</strong> view rows with data that is more than 10<br />
                    <strong>20-30</strong> view rows with data that is between 20 and 30.
                </p>
            </div>
        );

        return [
            {
                Header: "",
                maxWidth: 30,
                Filter: ({ filter, onChange }) =>
                    <NPHelpButton content={helpNode} title="Help" />,
                sortable: false,
                show: (hasGrant(Grants.TYPES.Order_CreateOrder) || hasGrant(Grants.TYPES.Order_CloneOrder)),
                Cell: (row) => {
                    return <span>
                        <select className='tst myopt handy' onChange={evt => { this.handleSelectChange(evt, evt.target.value, row, this); }} disabled={this.state.quickEdit.editTable}>
                            <option value="">...</option>
                            {hasGrant(Grants.TYPES.Order_CreateOrder) ? <option value="CreateNew">Create new</option> : ''}
                            {(hasGrant(Grants.TYPES.Order_CreateOrder) || hasGrant(Grants.TYPES.Order_CloneOrder)) && <option value="CopyThis">Create new with this order (selected item) as template</option>}
                            {(hasGrant(Grants.TYPES.Order_CreateOrder) || hasGrant(Grants.TYPES.Order_CloneOrder)) && <option value="CopyAll">Create new with this order (all items) as template</option>}
                            {(hasGrant(Grants.TYPES.Order_CreateOrder) || hasGrant(Grants.TYPES.Order_CloneOrder)) && <option value="CopyTo">Copy order row to existing order</option>}
                            {((hasGrant(Grants.TYPES.Order_CreateOrder) || hasGrant(Grants.TYPES.Order_CloneOrder)) && this.isRowOkForModification(row)) ? <option value="Edit">Modify this order</option> : ''}
                            {((hasGrant(Grants.TYPES.Order_CreateOrder) || hasGrant(Grants.TYPES.Order_CloneOrder)) && this.canRowOpenReleased(row)) ? <option value="OpenReleased">Set status back to preliminary</option> : ''}
                            {((hasGrant(Grants.TYPES.Order_CreateOrder) || hasGrant(Grants.TYPES.Order_CloneOrder)) && this.isRowOkForRelease(row)) ? <option value="Release">Release this order with items</option> : ''}
                            {(hasGrant(Grants.TYPES.Order_CreateOrder) && this.canRowCancelOrder(row)) ? <option value="CancelOrder">Cancel this order with items</option> : ''}

                        </select>
                    </span>
                }
            },

            {
                Header: "Order information",
                headerStyle: { background: '#DDDDDD' },
                columns: [
                    {
                        show: hasGrant(Grants.TYPES.General_ExpandOrderDetails),
                        expander: true,
                        width: 35,
                        Expander: ({ isExpanded, ...row }) =>
                            getExpander(row, 'ORDER_COMBO', this, isExpanded),
                        style: {
                            cursor: "pointer",
                            textAlign: "center",
                            userSelect: "none"
                        },
                    },
                    {
                        Header: "Order nr.",
                        accessor: "ORDER_COMBO",
                        maxWidth: 80
                    },
                    {
                        expander: true,
                        width: 35,
                        Expander: ({ isExpanded, ...row }) =>
                            getExpander(row, 'CLIENT_CODE_REGIONAL', this, isExpanded),
                        style: {
                            cursor: "pointer",
                            textAlign: "center",
                            userSelect: "none"
                        },
                    },
                    {
                        Header: "Client",
                        accessor: "CLIENT_CODE_REGIONAL",
                        maxWidth: 80,
                    },
                    {
                        Header: "Name",
                        accessor: "SHORT_NAME",
                        maxWidth: 100,
                        filterMethod: this.clientFilter
                    },
                    {
                        Header: "Ship to",
                        accessor: "SHIP_TO_COMBO",
                        maxWidth: 100,
                    },
                    {
                        Header: "Destination",
                        accessor: "DELIVERY_DESTINATION",
                        maxWidth: 100,
                    },
                    {
                        Header: "Call off",
                        accessor: "CALL_OFF",
                        maxWidth: 50,
                        style: { "textAlign": "right" },
                        filterMethod: filterNumber,
                    },
                    {
                        Header: "Customer po",
                        accessor: "CUSTOMER_PO",
                        maxWidth: 120,
                    },
                    {
                        Header: "Agent ref",
                        accessor: "SALES_AGENT_COMBO",
                        maxWidth: 120,
                    },
                    {
                        show: hasGrant(Grants.TYPES.General_ExpandOrderStatus),
                        expander: true,
                        width: 35,
                        Expander: ({ isExpanded, ...row }) =>
                            getExpander(row, 'ORDER_STATUS', this, isExpanded),
                        style: {
                            cursor: "pointer",
                            textAlign: "center",
                            userSelect: "none"
                        },
                    },
                    {
                        Header: "Order status",
                        accessor: "ITEM_STATUS",
                        minWidth: 90,
                        maxWidth: 110,
                    },
                    {
                        Header: "FSC",
                        accessor: "FSC",
                        maxWidth: 50,
                        style: { "textAlign": "center" },
                        filterMethod: filterNumber,
                    },
                    {
                        Header: "PEFC",
                        accessor: "PEFC",
                        maxWidth: 50,
                        style: { "textAlign": "center" },
                        filterMethod: filterNumber,
                    },
                    {
                        Header: "CW",
                        accessor: "CW_MARK",
                        maxWidth: 50,
                        style: { "textAlign": "center" },
                        filterMethod: filterNumber,
                    },
                    {
                        expander: true,
                        width: 35,
                        Expander: ({ isExpanded, ...row }) =>
                            getExpander(row, 'ORDER_ISSUED', this, isExpanded),
                        style: {
                            cursor: "pointer",
                            textAlign: "center",
                            userSelect: "none"
                        }
                    },
                    {
                        Header: "Issued",
                        accessor: "DATE_ISSUED",
                        maxWidth: 80,
                    },
                    {
                        Header: "Exmill Week",
                        accessor: "DELIVERYTIME_WEEK",
                        maxWidth: 84,
                        //Cell: (row) => <input defaultValue={row.value} onChange={e => this.editOrderCallback(row, e)} />
                        Cell: (row) => {
                            let grants = [Grants.TYPES.Order_QuickEdit, Grants.TYPES.Order_CreateOrder]
                            return <NPEditableCell
                                row={row} editCell={this.okToQuickEditRow(grants, row)}
                                onChangeCallback={this.editOrderCallback} useWeekInput={true} />
                        }
                    },
                    {
                        Header: "Exmill month",
                        accessor: "EXMILL_MONTH",
                        maxWidth: 84
                    },
                    {
                        // Header: () => (
                        //   <span title="Unit price committed">Unit price committed</span>
                        // ),
                        Header: "Sales price",
                        accessor: "UNIT_PRICE_COMMITTED",
                        style: { "textAlign": "right" },
                        maxWidth: 90,
                        minWidth: 90,
                        filterMethod: this.state.quickEdit.editTable ? function () {
                            return true;
                        }
                            : filterNumber,
                        // sortable: (row) => 
                        //     !this.okToQuickEditRow([Grants.TYPES.Order_QuickEdit, Grants.TYPES.Order_CreateOrder, Grants.TYPES.Order_EditPrice], row),
                        Cell: (row) => {
                            let grants = [Grants.TYPES.Order_QuickEdit, Grants.TYPES.Order_CreateOrder, Grants.TYPES.Order_EditPrice];
                            return <NPEditableCell
                                row={row} editCell={this.okToQuickEditRow(grants, row)}
                                onChangeCallback={this.editOrderCallback} />
                        }
                    },
                    {
                        Header: "Currency",
                        accessor: "CURRENCY_CODE",
                        maxWidth: 84,
                        show: hasGrant(Grants.TYPES.Order_EditPrice)

                    }
                ]
            },
            {
                Header: "Product",
                headerStyle: { background: '#EEEEEE' },
                columns: [
                    {
                        expander: true,

                        width: 35,
                        Expander: ({ isExpanded, ...row }) =>
                            getExpander(row, 'PRODUCT_CODE', this, isExpanded),
                        style: {
                            cursor: "pointer",
                            textAlign: "center",
                            userSelect: "none"
                        },
                    },

                    {
                        Header: "Code",
                        accessor: "PRODUCT_CODE",
                        minWidth: 120,
                        maxWidth: 130,
                        filterMethod: this.productCodeFilter
                    },
                    {
                        Header: "End use",
                        accessor: "END_USE_CODE",
                        minWidth: 80,
                        maxWidth: 130,
                    },
                    {
                        Header: "Product Name",
                        accessor: "GRADE_DESCRIPTION",
                        maxWidth: 170,
                    },
                    {
                        Header: "Description",
                        accessor: "ADESCRIPTION_ALT",
                        maxWidth: 80,
                    },
                    {
                        Header: <Convert.TextTo value_metric={"Format (mm)"} value_imperial={"Format (in)"}/>,
                        accessor: "FORMAT_UC",
                        filterMethod: filterNumber,
                        sortMethod: sortNumber,
                        minWidth: 100,
                    },
                    {
                        Header: <Convert.TextTo value_metric={"GSM"} value_imperial={"Basis Weight"}/>,
                        accessor: "BASIS_WEIGHT_UC",
                        filterMethod: filterNumber,
                        sortMethod: sortNumber,
                        maxWidth: 100,
                        id:'BASIS_WEIGHT_UC',
                        Cell: row => (
                            <div><Convert.AddSymbol check={row.original.BASIS_WEIGHT_UC}/>{row.original.BASIS_WEIGHT_UC}</div>
                        )
                    },
                    {
                        Header: <Convert.TextTo value_metric={"Width (mm)"} value_imperial={"Width (in)"}/>,
                        accessor: "WIDTH_UC",
                        filterMethod: filterNumber,
                        sortMethod: sortNumber,
                        maxWidth: 80,
                    },
                    {
                        Header: <Convert.TextTo value_metric={"Core (mm)"} value_imperial={"Core (in)"}/>,
                        accessor: "ROLL_CORE_FORMAT_UC"
                    }
                ]
            },
            {
                Header: "Info",
                headerStyle: { background: '#DDDDDD' },
                columns: [
                    {
                        Header: "Quantity",
                        accessor: "QUANTITY",
                        maxWidth: 80,
                        filterMethod: filterNumber,
                        Footer: (
                            <span>
                                <strong>{this.state.quantityTotal}</strong>
                            </span>
                        ),
                        style: { "textAlign": "right" },
                        Cell: (row) => {
                            let grants = [Grants.TYPES.Order_QuickEdit, Grants.TYPES.Order_CreateOrder];
                            let orderedBy = row.original.ORDERED_BY;
                            return (orderedBy === 'Q'
                                ? <NPEditableCell row={row} editCell={this.okToQuickEditRow(grants, row)} onChangeCallback={this.editOrderCallback} useWeekInput={false} />
                                : <span>{row.value}</span>
                            )
                        }

                    },
                    {
                        Header: <Convert.TextTo value_metric={"Weight (kg)"} value_imperial={"Weight (lb)"}/>,
                        accessor: "WEIGHT_UC",
                        maxWidth: 80,
                        filterMethod: filterNumber,
                        Footer: (
                            <span>
                                <strong>{this.state.weightTotal}</strong>{" "}
                            </span>
                        ),
                        style: { "textAlign": "right" },
                        Cell: (row) => {
                            let grants = [Grants.TYPES.Order_QuickEdit, Grants.TYPES.Order_CreateOrder];
                            return (row.original.ORDERED_BY === 'W'
                                ? <NPEditableCell row={row} editCell={this.okToQuickEditRow(grants, row)} onChangeCallback={this.editOrderCallback} useWeekInput={false} />
                                : <span>{row.value}</span>
                            )
                        }
                    },
                    {
                        Header: "Stock Quantity",
                        accessor: "STOCK_QUANTITY",
                        filterMethod: filterNumber,
                        Footer: (
                            <span>
                                <strong>{this.state.stockquantityTotal}</strong>{" "}
                            </span>
                        ),
                        style: { "textAlign": "right" },

                    },
                    {
                        Header: <Convert.TextTo value_metric={"Stock weight (kg)"} value_imperial={"Stock weight (lb)"}/>,
                        accessor: "STOCK_WEIGHT_UC",
                        minWidth: 120,
                        filterMethod: filterNumber,
                        Footer: (
                            <span>
                                <strong>{this.state.stockweightTotal}</strong>{" "}
                            </span>
                        ),
                        style: { "textAlign": "right" },
                    },
                    {
                        Header: "Shipped quantity",
                        accessor: "SHIPPED_QUANTITY",
                        minWidth: 110,
                        maxWidth: 130,
                        filterMethod: filterNumber,
                        Footer: (
                            <span>
                                <strong>{this.state.shippedquantityotal}</strong>{" "}
                            </span>
                        ),
                        style: { "textAlign": "right" }
                    },
                    {
                        Header: <Convert.TextTo value_metric={"Shipped weight (kg)"} value_imperial={"Shipped weight (lb)"}/>,
                        accessor: "SHIPPED_WEIGHT_UC",
                        minWidth: 120,
                        filterMethod: filterNumber,
                        Footer: (
                            <span>
                                <strong>{this.state.shippedweightTotal}</strong>{" "}
                            </span>
                        ),
                        style: { "textAlign": "right" }
                    },

                ]
            }
        ];
    }

    help() {
        alert('Buttons:\nReset: Resets filters, sorting, column widths and sets page to page 1.\n' +
            'Excel: Exports the data to excel according to filters and sorting.\n\n' +
            'To select an unknown client, please select it from the "Client" dropdown control.\n' +
            'To select an unknown product-code, please select it from the "Product code" dropdown control.\n\n' +
            'Filters:\nBelow the columns filter we have input text boxes that can be used for filtering\n' +
            'If a text-box for a column is empty, no filtering for that column will be done.\n' +
            'If the data is left-aligned and the text-box is not empty, the filter will remove rows that do not contain the the text in the text-box.\n' +
            'Examples follows for right-aligned (numbers):\n' +
            'Empty text-box, no filtering.\n>10 filters rows with column data with 10 or less\n' +
            '<10 filters rows with column data 10 or more\n20-30 filters rows with data that is not between 20 and 30.');
    }

    // excelExport() {
    //     export2Excel(this.props.apiToken, this.reactTable.getReactTable(), "Orders.xlsx");
    //     this.GAtrackHandler();
    // }

    help() {
        alert('Buttons:\nReset: Resets filters, sorting, column widths and sets page to page 1.\n' +
            'Excel: Exports the data to excel according to filters and sorting.\n\n' +
            'To select an unknown client, please select it from the "Client" dropdown control.\n' +
            'To select an unknown product-code, please select it from the "Product code" dropdown control.\n\n' +
            'Filters:\nBelow the columns filter we have input text boxes that can be used for filtering\n' +
            'If a text-box for a column is empty, no filtering for that column will be done.\n' +
            'If the data is left-aligned and the text-box is not empty, the filter will remove rows that do not contain the the text in the text-box.\n' +
            'Examples follows for right-aligned (numbers):\n' +
            'Empty text-box, no filtering.\n>10 filters rows with column data with 10 or less\n' +
            '<10 filters rows with column data 10 or more\n20-30 filters rows with data that is not between 20 and 30.');
    }

    excelExport() {
        const isImperial = window.sessionStorage.getItem('UnitConversion') === "IMPERIAL";
        export2Excel(this.props.apiToken, this.reactTable.getReactTable(), "Orders.xlsx", isImperial);
        this.GAtrackHandler();
    }

    GAtrackHandler(e) {
        ReactGA.event({
            category: "User action",
            action: "Order was exported as Excel",
        });
    }

    getClearedState() {
        let data = this.props.data;
        return ({
            sorted: [],
            data: data,
            page: 0,
            pageSize: 10,
            expanded: {},
            resized: [],
            filtered: [],
            filteredTemp: [],
            showModal: false,
            selectedProductCode: '',
            productCodeFilter: null,
            clientFilter: null,
            showSpinnerModal: false,
            modalContent: '',
            modalTitle: '',
            releasingOrder: false,
            cloneableOrders: [],
            selectedCloneableOrder: null,
            isLoading: false,
            quickEdit: {
                editTable: false,
                editedOrders: [],
                savingOrders: false,
            },
            ...this.getSums(data)
        });
    }

    tell(txt, row) {
        setDataForExpansion(txt, row, this.props.apiToken, this);
    }

    getOptionLabelAndValue(values) {
        values.sort();
        values = uniq(values);
        return values.map(v => ({ value: v, label: v }));
    }

    // handleProductCodeSelectChange(item) {
    //   this.setState(state => {
    //     const filtered = state.filtered.filter(x => x.id !== 'PRODUCT_CODE');
    //     if (item && item.value) {
    //       filtered.push({ id: 'PRODUCT_CODE', value: item.value });
    //     }
    //     return {
    //       productCodeFilter: item,
    //       filtered: filtered,
    //     };
    //   });
    // }

    // handleClientSelectChange(item) {
    //   this.setState(state => {
    //     const filtered = state.filtered.filter(x => x.id !== 'CLIENT_CODE_REGIONAL');
    //     if (item && item.value) {
    //       let tmp = item.value.split('\xa0');
    //       filtered.push({ id: 'CLIENT_CODE_REGIONAL', value: tmp[0] });
    //     }
    //     return {
    //       clientFilter: item,
    //       filtered: filtered,
    //     };
    //   });
    // }



    getSums(data) {
        let result = {
            quantityTotal: getSum(data, "QUANTITY"),
            weightTotal: getSum(data, "WEIGHT_UC"),
            stockquantityTotal: getSum(data, "STOCK_QUANTITY"),
            stockweightTotal: getSum(data, "STOCK_WEIGHT_UC"),
            shippedquantityotal: getSum(data, "SHIPPED_QUANTITY"),
            shippedweightTotal: getSum(data, "SHIPPED_WEIGHT_UC"),
        };
        return result;
    }

    updateSums() {
        let states = this.getSums(getFilteredData(this.reactTable.getReactTable()));
        this.setState(states);
    }

    clearCurrentExpandforAll() {
        let d = getFilteredData(this.reactTable.getReactTable());
        this.currentExpand = '';
        d.filter(dt => dt.TAG).forEach(dt => {
            delete dt.TAG;
        });
    }

    setReactTable(reactTable) {
        if (reactTable != null) {
            this.ReactTable = reactTable;
        }
    }

    reloadWithClient() {
        this.props.reloadData();
        this.props.getClientCodeData(true);
    }

    refreshData() {
        this.setState({ showSpinnerModal: false })
        this.props.refreshData(this);
    
    }

    editTable() {
        if (this.state.quickEdit.editTable) {
            //Undo operation
            let filters = this.state.filteredTemp;
            let sort = this.state.sortedTemp;
            this.setState({ quickEdit: { editTable: false, editedOrders: [] }, filtered: filters, sorted: sort });
            this.refreshData();
        }
        else {
            //Start operation
            let filters = this.state.filtered;
            let sorted = this.state.sorted;
            let originalOrders = this.reactTable.getReactTable().state.sortedData.map((row) => row._original);
            this.setState({ quickEdit: { editTable: true, editedOrders: [] }, data: originalOrders, filtered: [], sorted: [], filteredTemp: filters, sortedTemp: sorted });
        }
    }

    saveEditedOrders() {
        this.toggleOrderModal(true);
    }

    saveConfirmedOrders() {


        //
        // J_W
        //
        console.log("this.state.quickEdit.editedOrders: \n" + JSON.stringify(this.state.quickEdit.editedOrders) );

        let orders = this.state.quickEdit.editedOrders.map((element) => {
            // if (element.order.EXMILL.includes('-')) {
            //     element.order.DELIVERYTIME_WEEK = null;
            // }
            element.editedValues.forEach((value) => {
                switch (value.column) {
                    // case 'EXMILL':
                    //     element.order.DELIVERYTIME_WEEK = element.order.EXMILL;
                    //     break;
                    
                    case 'WEIGHT_UC':
                    case 'QUANTITY':
                        let { weight, quantity } = this.getWeightOrQuantity(element.order);
                        element.order.WEIGHT_UC = weight;
                        element.order.QUANTITY = quantity;
                        break;
                }
            })
            return element.order;

        })

        this.toggleOrderModal(false);


        this.quickSaveOrderItems(this, orders);
    }

    toggleOrderModal(value) {
        let quickEdit = this.state.quickEdit;
        quickEdit.showModal = value;
        this.setState({ quickEdit: quickEdit })
    }


    getWeightOrQuantity(row) {
        let orderRow = Object.assign({}, row);

        if (orderRow.ADESCRIPTION === 'RULL' || orderRow.ADESCRIPTION === 'ARK') {
            
            console.log("PEEK orderRow.NET_WEIGHT: " + orderRow.NET_WEIGHT);
            console.log("PEEK orderRow.NET_WEIGHT_UC: " + orderRow.NET_WEIGHT_UC);

            let w = orderRow.NET_WEIGHT_UC;

            if (orderRow.ADESCRIPTION === "RULL") {

                let palletQuantity = orderRow.ROLLS_PER_PALLET;
                let rollLengthTarget = orderRow.ROLL_LENGTH_TARGET_UC;

                if (orderRow.ORDERED_BY === 'Q') {
                    orderRow.WEIGHT_UC = (w * orderRow.QUANTITY / palletQuantity).toFixed(1);
                }
                else if (orderRow.ORDERED_BY === 'W') {
                    orderRow.QUANTITY = this.getQuantityByWeight(orderRow.WEIGHT_UC, (w / palletQuantity));//Math.ceil(datarow.WEIGHT/w);
                }
                else if (orderRow.ORDERED_BY === 'M') {
                    orderRow.WEIGHT_UC = (((w / palletQuantity) / rollLengthTarget) * orderRow.QUANTITY).toFixed(1);
                    orderRow.ART_QUANTITY = this.getQuantityByWeight(orderRow.WEIGHT_UC, (w / palletQuantity));
                }
            }
            else {
                if (orderRow.ORDERED_BY === 'Q') {
                    orderRow.WEIGHT_UC = (w * orderRow.QUANTITY).toFixed(1);
                }
                else if (orderRow.ORDERED_BY === 'W') {
                    orderRow.QUANTITY = this.getQuantityByWeight(orderRow.WEIGHT_UC, w);//Math.ceil(datarow.WEIGHT/w);
                }
            }
        }

        return { weight: orderRow.WEIGHT_UC, quantity: orderRow.QUANTITY };
    }

    getQuantityByWeight(weight, netweight) {
        if (weight == 0)
            return 0;

        let tmp = (weight / netweight).toFixed(4);
        let calculated = parseFloat(tmp);
        let sum = Math.floor(calculated);
        return sum < 1 ? 1 : sum;
    }

    editOrderCallback(row, value, validated) {
        let editedOrders = this.state.quickEdit.editedOrders;
        let orderIndex = editedOrders.findIndex((editedRow) => editedRow.order.ORDER_NUMBER == row.original.ORDER_NUMBER && editedRow.order.ORDER_ITEM_NUMBER == row.original.ORDER_ITEM_NUMBER);


        if (orderIndex >= 0) {
            editedOrders[orderIndex].order[row.column.id] = value;
            editedOrders[orderIndex].validInput = validated;
            if (editedOrders[orderIndex].editedValues.find(eo => eo.column === row.column.id) === undefined) {
                editedOrders[orderIndex].editedValues.push({ column: row.column.id, originalValue: row.original[row.column.id] });
            }

        }
        else {
            let order = Object.assign({}, row.original);
            order[row.column.id] = value;

            editedOrders.push({ editedValues: [{ column: row.column.id, originalValue: row.original[row.column.id] }], validInput: validated, order: order });
        }

        let tempData = this.state.data;
        tempData[row.index][row.column.id] = value;

        this.setState({ data: tempData, quickEdit: { editTable: true, editedOrders: editedOrders } });
    }

    okToSaveQuickedit() {
        let editedOrders = this.state.quickEdit.editedOrders;
        if (editedOrders.length > 0) {
            return editedOrders.every(order => order.validInput === true)
        }
        else {
            return false;
        }
    }

    okToQuickEditRow(grants, row) {
        grants.forEach((grant) => {
            if (hasGrant(grant) === false) return false;
        })
        return this.state.quickEdit.editTable && row.original.ITEM_STATUS !== "Shipped";
    }


    closeSpinnnerModal(){
        this.setState({showSpinnerModal: false, modalTitle: '', modalContent: ''});
    }

    render() {
        const { data, apiToken } = this.props;
        if (this.state.isLoading) {
            return <LoadingSpinner isLoading={true} />
        }

        let quickEdit = this.state.quickEdit;
        let hasQuickEditedOrders = quickEdit.editedOrders.length > 0;

        let saveQuickEditChanged = {
            backgroundColor: hasQuickEditedOrders ? 'pink' : '#00529c',
            border: hasQuickEditedOrders ? '2px solid red' : ''
        };
        // const clientcodes = this.getOptionLabelAndValue([...data.map((v => v.CLIENT_CODE_REGIONAL + '\xa0\xa0\xa0\xa0' + v.SHORT_NAME))]);
        // const productCodes = this.getOptionLabelAndValue([...data.map((v => v.PRODUCT_CODE))]);
        // const selectedClientFilter = this.state.clientFilter && this.state.clientFilter.value;
        // const selectedProductCode = this.state.productCodeFilter && this.state.productCodeFilter.value;
        return (
            <div>
                <OrderConfirmationModal
                    showModal={this.state.quickEdit.showModal}
                    changedOrders={this.state.quickEdit.editedOrders}
                    toggleModal={this.toggleOrderModal}
                    confirm={this.saveConfirmedOrders}
                />
                <Dialog ref={(el) => { this.dialog = el }} />
                <NPSpinnerModal showModal={this.state.showSpinnerModal} title={this.state.modalTitle} content={this.state.modalContent} isLoading={this.state.releasingOrder || this.state.quickEdit.savingOrders} closeAction={this.closeSpinnnerModal}/>
                <Row>
                    <Col xs={12}>
                        <Form inline>
                            <FormGroup>
                                <Button bsStyle="primary" bsSize="small" onClick={this.resetState} disabled={this.state.quickEdit.editTable}>Reset</Button>
                                {hasGrant(Grants.TYPES.General_ExportToExcel) &&
                                    <Button bsStyle="primary" bsSize="small" className="margin-left-10" onClick={this.excelExport} disabled={this.state.quickEdit.editTable}>Excel</Button>}
                                {hasGrant(Grants.TYPES.Order_CreateOrder) &&
                                    <Button bsStyle="primary" bsSize="small" className="margin-left-10" onClick={() => { this.props.viewOrderCommand(1, '0', 0); }} disabled={this.state.quickEdit.editTable}>New Order</Button>}
                                {hasGrant(Grants.TYPES.Order_QuickEdit) && hasGrant(Grants.TYPES.Order_CreateOrder) &&
                                    <Button bsStyle="primary" bsSize="small" className="margin-left-10" onClick={this.editTable} >{(quickEdit.editTable ? 'Undo quick' : 'Quick') + ' edit'}</Button>}
                                {hasGrant(Grants.TYPES.Order_QuickEdit) && hasGrant(Grants.TYPES.Order_CreateOrder) && this.state.quickEdit.editTable &&
                                    <Button bsStyle="primary" bsSize="small" className="margin-left-10" disabled={this.okToSaveQuickedit() === false} onClick={this.saveEditedOrders} style={saveQuickEditChanged}>Save quick edit</Button>}

                            </FormGroup>
                            {this.state.quickEdit.editTable &&
                                <FormGroup>
                                    <div className="margin-left-10">
                                        <NPHelpButton content={quickEditHelpNode} title="Quick edit help" />
                                    </div>
                                </FormGroup>}

                            <FormGroup>
                                {hasGrant(Grants.TYPES.Order_QuickEdit) && hasGrant(Grants.TYPES.Order_CreateOrder) && this.state.quickEdit.editTable && hasQuickEditedOrders &&
                                    <span className="margin-left-10">  Unsaved orders</span>}
                            </FormGroup>
                            <FormGroup className="pull-right">
                                <Button bsStyle="primary" bsSize="small" onClick={this.refreshData} disabled={this.state.quickEdit.editTable}>Refresh</Button>
                            </FormGroup>
                        </Form>




                    </Col>


                    <Col xs={12}>
                        <NPReactTable
                            className="margin-top-5 np-react-table"
                            data={this.state.data}
                            //ref={(r) => { this.setReactTable(r)}}
                            ref={(r) => { this.reactTable = r }}
                            columns={this.getcolumns()}
                            defaultFilterMethod={filterMultiple}
                            filterable={!this.state.quickEdit.editTable}
                            sortable={!this.state.quickEdit.editTable}
                            filterAll
                            defaultPageSize={10}
                            // Controlled props
                            sorted={this.state.sorted}
                            page={this.state.page}
                            pageSize={this.state.pageSize}
                            expanded={this.state.expanded}
                            resized={this.state.resized}
                            filtered={this.state.filtered}
                            // Callbacks
                            onSortedChange={sorted => this.setState({ sorted, expanded: {} })}
                            onPageChange={
                                page => {
                                    this.clearCurrentExpandforAll();
                                    this.setState({ page, expanded: {} });
                                }

                            }
                            onPageSizeChange={(pageSize, page) => {
                                this.clearCurrentExpandforAll();
                                this.setState({ page, pageSize, expanded: {} });
                            }
                            }

                            onResizedChange={resized => this.setState({ resized })}
                            onFilteredChange={filtered => {
                                this.updateSums();
                                this.clearCurrentExpandforAll();
                                this.setState({ filtered, page: 0, expanded: {} })
                            }
                            }
                            SubComponent={row => {
                                let r = row.original;
                                let t = 'EXP_' + r.TAG;
                                if (r.TAG && r.TAG !== '' && r[t]) {
                                    return r[t];
                                }
                            }
                            }
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default OrderSearchDataTable;
